import Vue from 'vue'
import { RUN_USER_LOGIN,RUN_USER_LOGOUT,RUN_CHANGE_PASSWORD,RUN_STATE_LOAD,GET_TOKEN,SET_STATE,SET_STATE_PERSIST_LOCAL,SET_TOGGLE_LOADER,SET_INFO,GET_USER,RUN_GENERATE_2FA_QRCODE , RUN_VERIFY_2FA_QRCODE , RUN_DISABLE_2FA_QRCODE, RUN_USER_LOGIN_2FA} from '../types'
import * as types from '@/types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'



export const actions = {
	//================================2FA===========================================
	[RUN_GENERATE_2FA_QRCODE]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.src_data = result.res_data
			}else{
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = true
				}
				_messageDisplayFunction(credentials.localParams.parameter.$parent,result.res_data.code,'error')
			}
		})
	},
	[RUN_VERIFY_2FA_QRCODE]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 1
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 1						
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				// user = atob(decodeURIComponent(escape(atob(user)))) ;	user = JSON.parse(user)
				// user.profile.gAuthenticatorEnabled = 1	

				// const val = btoa(unescape(encodeURIComponent(JSON.stringify(user))))					
				// localStorage.setItem('user', btoa(val))
				credentials.localParams.parameter.div_show = ''
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = false
					
				}else{
					credentials.localParams.parameter.otp = ''
					credentials.localParams.parameter.div_show = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter.$parent,'2FA Enabled successfully','success')
			}else{
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = true
				}
				_messageDisplayFunction(credentials.localParams.parameter.$parent,result.res_data.code,'error')
				
			}
		})
	},
	[RUN_DISABLE_2FA_QRCODE]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.DisableOtp = ''
				credentials.localParams.parameter.div_show = ''
				credentials.localParams.parameter.generateQrCode()
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 0
				commit(SET_STATE, user_json)


				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 0						
				localStorage.setItem('user', btoa(JSON.stringify(user)))

				// let user = decodeURIComponent(escape(atob(localStorage.getItem('user'))))
				// user = atob(user)	;	user = JSON.parse(user)
				// user.profile.gAuthenticatorEnabled = 0		
				// const val = btoa(unescape(encodeURIComponent(JSON.stringify(user))))					
				// localStorage.setItem('user', btoa(val))
				_messageDisplayFunction(credentials.localParams.parameter.$parent,'2FA Disabled successfully','success')
			}else{
				//console.log("result.res_msg",result)
				_messageDisplayFunction(credentials.localParams.parameter.$parent,result.res_data.code,'error')
			}
		})
	},

	[RUN_USER_LOGIN_2FA]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				result.res_data.user.loggedIn = true
				commit(SET_STATE, result.res_data.user)

				// const val = btoa(unescape(encodeURIComponent(JSON.stringify(result.res_data.user))))					
				// localStorage.setItem('user', btoa(val))
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				if(localStorage.getItem('last_route')){
					credentials.localParams.parameter.$router.replace( localStorage.getItem('last_route') )
				}else{
					credentials.localParams.parameter.$router.replace('/dashboard')
				}
				localStorage.removeItem("last_route");
				_messageDisplayFunction(credentials.localParams.parameter,'login successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  	},

  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_LOGIN, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				if(parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 1){
					credentials.localParams.parameter.gAuthenticatorEnabled = true
				}else{
					result.res_data.user.loggedIn = true
					let role_array = result.res_data.user.roles.split('&')
					result.res_data.user.roles = role_array
					
					commit(SET_STATE, result.res_data.user)
					localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
					
					credentials.localParams.parameter.$router.replace('/dashboard'); 
					credentials.localParams.parameter.$notify({
						group: 'foo',
						type : 'success',
						text: 'login successfully',
						duration: 10000,
						closeOnClick : true
					});
				}
			}else{
				credentials.localParams.parameter.message = result.res_data
				credentials.localParams.parameter.message_type = 'error'
			}
		})
  	},
	[RUN_USER_LOGOUT]({commit, state, getters}, getdata) {
		RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_ADMIN_LOGOUT, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				_handleLogout(data, commit, {router: getdata.router,parameter: getdata.parameter, forward:true})
			},
			(e, d, s) => {
				_handleLogout(e, commit, {router: getdata.router, forward:true})
			}
		)
	},

	[RUN_CHANGE_PASSWORD]({commit, state, getters}, credentials) {
		//_executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials.globalParams , credentials.localParams,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
		_executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			console.log()
		  if(!error){
			  //_messageDisplayFunction(credentials.localParams.parameter.$parent,'password changed successfully','success')
			  
				credentials.localParams.parameter.$notify({
					group: 'foo',
					type : 'success',
					text: 'password changed successfully',
					duration: 10000,
					closeOnClick : true
				});
				credentials.localParams.parameter.old_password = ''
                credentials.localParams.parameter.new_password = ''
                credentials.localParams.parameter.confirm_password = ''
                credentials.localParams.parameter.submitted = false
		  }else{
		  	credentials.localParams.parameter.$notify({
				group: 'foo',
				type : 'error',
				text: result.res_data.msg,
				duration: 10000,
				closeOnClick : true
			});
			//credentials.localParams.parameter.message = result.res_data.msg
			credentials.localParams.parameter.message_type = 'error'
			//  _messageDisplayFunction(credentials.localParams.parameter.$parent,result.res_data,'error')
		  }
	  })
	},
	  
	[RUN_STATE_LOAD] ({commit, dispatch, state, getters}) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}
		commit(SET_STATE, user)
		if(user !== null && user !==''){
			RxFactory.post(Enpoints.BASE_URL + "/get/fresh/user/data", {}  , {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							data.data.user.loggedIn = true
							let role_array = data.data.user.roles.split('&')
							data.data.user.roles = role_array
				
							commit(SET_STATE, data.data.user)
							localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
							
						}
					}
				},
				e => {					
					_handleErrorResponse(e, commit)
				}
			)
		}
	},
}

//------------------------------------------------functions----------------------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}

function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}

function _handleLogout (data, commit,options,getters) {
	const router = options.router
	let user = {
		active: 0,
		country: '',
		created: '',
		email: '',
		profile: {
			firstname: '',
			lastname: '',
			pid: '',
			cid: ''
		},
		roles: '',
		token: false,
		username: '',
		loggedIn: false
	}
	
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	localStorage.clear()
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		options.parameter.$notify({
			group: 'foo',
			type : 'success',
			text: 'logout successfully',
			duration: 10000,
			closeOnClick : true
		});
		router.replace('/')
	}
}

function _messageDisplayFunction(getParameter,getMessage,msgType){
	getParameter.$notify({
		group: 'foo',
		type : msgType,
		text: getMessage,
		duration: 4000,
		closeOnClick : true
	});
}


function _executeApi (apiLink, globalParams, localParams,commit, callback) {
	try{
		let response_array = []
		localParams.parameter.pageLoader = true
		RxFactory.post(Enpoints.BASE_URL + apiLink, globalParams)
		.map(response => response.data)
		.subscribe(data => 
		{	localParams.parameter.pageLoader = false
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data
					callback(false, response_array)
				}
				else{
					response_array.res_data = data.msg
					callback(true, response_array)
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){	_handleErrorResponse(ex, commit) }
}




// WEBPACK FOOTER //
// ./src/store/actions.js